import React from "react";
import Ourservices from "./OurServices";

const Services = () => {
  return (
    <div>
      <Ourservices />
    </div>
  );
};

export default Services;
